import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SharedFacade,
  ProjectsFacade,
  customEncode,
  customDecode,
  encrypt,
  decrypt,
} from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ProjectScenarioFillingDataGridService } from './project-scenario-filling-data-grid.service';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewportScroller } from '@angular/common';
import { AccessPermissionService, CustomModalService } from '@piqet-angular/shared';
import { catchError, of, finalize, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GridIconComponent } from 'libs/ui/src/lib/grid-icon/grid-icon.component';

@Component({
  selector: 'piqet-angular-project-scenario-fill-data',
  templateUrl: './project-scenario-fill-data.component.html',
  styleUrls: ['./project-scenario-fill-data.component.scss'],
})
export class ProjectScenarioFillDataComponent implements OnInit {
  checkboxValue = false;
  nextRoute: any;
  sideBarData: any;
  scenarioId: any;
  eId: any;
  excludeAllMenus: any = false;
  searchData: any = '';
  headerData = {
    materialName: 'Filling',
  };
  activatedRoute: any;
  columnDefs!: ColDef[];
  activatedRouteProjectId: any;
  isScreenDisabled: any;
  navigationConfig: any;
  incorrectFillingValueMessage: string = 'Please add the missing filling country.';
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  showIncorrectFillingNotification: boolean = false;
  packageScenarioId: any;
  menuDataForRouting: any;
  isHideSideBar = false;
  fillDataList: any;
  deleteFilling: Subscription;
  editFillingSuccess: Subscription;
  sideBarDataObs: Subscription;
  menuDataObs: Subscription;
  backRouteType: any;
  fillingDataWithComponent: any;
  showEdit: boolean = false;
  fillingId: any;
  constructor(
    private projectScenarioFillingDataGridService: ProjectScenarioFillingDataGridService,
    public sharedFacade: SharedFacade,
    public projectFacade: ProjectsFacade,
    public viewportScroller: ViewportScroller,
    public accessService: AccessPermissionService,
    public route: ActivatedRoute,
    private projectService: ProjectsService,
    private router: Router,
    public sharedService: SharedService,
    private modal: CustomModalService,
    private toaster: ToastrService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
      this.eId = value['eId'];
      this.getFillData();
    });

    this.sideBarDataObs = this.sharedService.sideBarData.subscribe((res: any) => {
      this.sideBarData = res;
    });

    this.menuDataObs = this.sharedService.menuData$.subscribe((res: any) => {
      this.menuDataForRouting = res;
    });

    this.deleteFilling = this.projectScenarioFillingDataGridService.deleteFillingData$.subscribe(
      async deleteData => {
        this.deleteFillData(deleteData[0]);
      }
    );

    this.editFillingSuccess =
      this.projectScenarioFillingDataGridService.editFillingSuccessData$.subscribe(
        async deleteData => {
          this.getFillData();
        }
      );
  }

  ngOnInit() {
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute, 'packaging');
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  onCheckboxChange(eve: any) {
    this.checkboxValue = eve.target.checked ? true : false;
    this.projectService.disableFilling(this.checkboxValue, this.scenarioId).subscribe();
  }

  async getFillData() {
    this.fillDataList = (
      await this.projectService.getProjectFillingListAsync(
        this.packageScenarioId,
        this.activatedRouteProjectId
      )
    ).data;
    this.showIncorrectFillingNotification = this.fillDataList?.incorrectFillingDataList.length > 0;
    if (this.fillDataList?.fillingTempDatalistIteams?.length > 0) {
      this.fillDataList.fillingTempDatalistIteams.map((item: any) => {
        item.fillingTransportDetail = item.fillingTransportDetail?.map((data: any) => {
          return {
            ...data,
            cityName: data.originName,
            originId: data.cityId,
          };
        });
      });
      const dataList = this.fillDataList?.fillingTempDatalistIteams.map((data: any) => {
        return {
          ...data,
          fillingProcessData: this.fillDataList.fillingDataList,
          id: this.fillDataList?.fillingId,
        };
      });
      this.fillingDataWithComponent = dataList;
      const allItemsAreComponents = this.fillingDataWithComponent.every(
        (item: any) => item.isComponent
      );
      this.columnDefs =
        this.projectScenarioFillingDataGridService.projectFillingColumnWithComponent(
          allItemsAreComponents
        );
    } else {
      this.fillingDataWithComponent = this.fillDataList?.fillingDataList;
      this.columnDefs = this.projectScenarioFillingDataGridService.projectFillingColumn();
    }
    this.fillingId = this.fillDataList?.fillingId;
    this.checkboxValue = this.fillDataList.isExcludeFillingData;
    this.excludeAllMenus = this.fillDataList.excludeAll;
    this.isScreenDisabled = this.fillDataList.isLockProject;

    this.navigationConfig = {
      scenarioId: this.scenarioId,
      packageScenarioId: this.packageScenarioId,
      eId: this.eId,
      activatedRouteProjectId: this.activatedRouteProjectId,
      activatedRoute: this.activatedRoute,
      isProjectLocked: this.isScreenDisabled,
      isProductPage: true,
    };
  }

  excludeAll(eve: any) {
    this.excludeAllMenus = eve.target.checked ? true : false;
    this.projectService.disableAllProjectMenus(this.excludeAllMenus, this.scenarioId).subscribe();
  }

  async addFillDataModal(scenarioId: any, id: any, label: any) {
    this.projectFacade.clearComponentTransport();
    if (id) {
      this.projectFacade.openNewAddProjectFillData(
        scenarioId,
        id,
        'Review filling',
        this.activatedRouteProjectId
      );
    } else {
      let response = await this.projectService.getProjectFillingAddUpdateAsync(scenarioId, id);
      this.modal.invoke('newAddProjectFillData', {
        initialState: {
          fillingData: response.data,
          label: label,
          scenarioId: scenarioId,
          projectId: this.activatedRouteProjectId,
        },
        class: 'modal-xl',
      });
      this.modal.ref?.content.saveNewMyProjectFillingEvent.subscribe(
        (saveNewMyProjectFillingEvent: any) => {
          this.addFillData(saveNewMyProjectFillingEvent);
        }
      );
    }
  }

  addFillData(data: any) {
    this.projectService
      .addUpdateProjectFilling(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.projectFacade.clearProduct();
          this.getFillData();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  deleteFillData(data: any) {
    this.projectService
      .deleteProjectFilling(data.fillingProcessId, data.id)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getFillData();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  findNextRoute() {
    const activeIndex = this.menuDataForRouting.findIndex(
      (x: any) => x.link == this.activatedRoute
    );
    const nextIndex = activeIndex + 1;
    this.nextRoute = this.menuDataForRouting[nextIndex].link;
  }

  startTour() {}

  ngOnDestroy() {
    this.deleteFilling.unsubscribe();
    this.editFillingSuccess.unsubscribe();
    this.sideBarDataObs.unsubscribe();
    this.menuDataObs.unsubscribe();
  }
}
